<script>
import { getDateFormat } from '@utils/medical-date'
import {
  formatLongDate,
  formatShortDateMonth,
  formatShortDateYear,
} from '@utils/format-date'

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    field: {
      type: String,
      default: null,
    },
    part: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      medicalDateDialog: this.dialog,
    }
  },
  computed: {
    textFieldDate() {
      if (this.field !== null && this.field !== undefined) {
        if (this.part === 'day') {
          const val = getDateFormat(this.part, this.field)
          return formatLongDate(val)
        } else if (this.part === 'month') {
          const val = getDateFormat(this.part, this.field)
          return formatShortDateMonth(val)
        } else if (this.part === 'year') {
          const val = getDateFormat(this.part, this.field)
          return formatShortDateYear(val)
        }
        return getDateFormat(this.part, this.field)
      }

      if (this.field === null && this.part === 'past') {
        return 'In the past'
      }
      return ''
    },
  },
  methods: {
    formatLongDate,
    closeMedicalDate() {
      this.medicalDateDialog = false
      this.$emit('update:dialog', false)
    },
    setMedicalDate(medicalDate, past) {
      this.medicalDateDialog = false
      this.$emit('setMedicalDate', medicalDate, past)
    },
    showMedicalDate() {
      this.$emit('showMedicalDate')
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="medicalDateDialog"
    persistent
    v-bind="$attrs"
    max-width="850px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :content-class="'elevation-0' + ' ' + $style.dialogMenu"
    v-on="$listeners"
  >
    <BaseMedicalDatePicker
      v-if="medicalDateDialog"
      :title="$t(title)"
      :medical-date="field"
      :part="part"
      color="blue"
      @closeMedicalDate="closeMedicalDate"
      @setMedicalDate="setMedicalDate"
    ></BaseMedicalDatePicker>
    <template v-slot:activator="{ on }">
      <v-text-field
        :disabled="disabled"
        :value="textFieldDate"
        :placeholder="$t(title)"
        rounded
        readonly
        role="button"
        :class="$style.hrMedicalDatePicker"
        v-bind="$attrs"
        v-on="on"
        @click="showMedicalDate"
      ></v-text-field>
    </template>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
.dialogMenu {
  border-radius: 16px !important;
}
.hrMedicalDatePicker {
  border-radius: 15px !important;
}
</style>
